<template>
    <paper class='bill'>
        <m-pane
            ref="tablePage"
            :config="config"
            :searchTotalTitle="config.searchTotalTitle"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="currentPage"
            searchId="billQuery"
            pageID="bill"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn">
            </div>
             <div slot="page-module-btn">
                <el-button type="success" @click="batchSettle" v-has="'07030012'">结算申请</el-button>
             </div>
        </m-pane>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleCloseDialog">
            <div>
                <div
                    v-for="item in paymentMsg.split(',')"
                    :key="item">
                        {{ item }}
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="isSettleFlag" @click="handleClose">   否  </el-button>
                <el-button v-if="isSettleFlag" type="primary" @click="handlePayment">  是  </el-button>
                <el-button v-if="!isSettleFlag" type="primary" @click="handleClose"> 关闭 </el-button>
            </span>
        </el-dialog>
    </paper>
</template>

<script>
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import formatTime from '@/utils/common.js';
import { del } from '../../../components/judge/bmsModular';
import { getBillLists, batchSettlement, checkPaymentHandler, updateApApplyEisInvoicing } from '../../../api/billApi.js';
import common from '../../../common/common';
const { initSessionData } = common;
const SETTLE_APPLY = '已结算申请';
const SETTLE_APPLY_STATUS = 40;// 已结算申请状态
const INDEPENDENT_SETTLEMENT = 1; // 默认流程状态
export default {
    name: 'billIndex',
    components: { mPane, paper },
    data() {
        return {
            selected: [],
            searchDataLists: {
                billData: ''
            },
            currentPage: 1,
            selectData: [],
            searchObj: {
                pageNo: 1,
                pageSize: 10
            },
            pageTotal: 0,
            totalData: [],
            paymentMsg: '',
            responseData: [],
            loading: false,
            dialogVisible: false,
            isSettleFlag: true,
            isCloseSettlement: true,
            paymentParams: [],
            config
        };
    },
    methods: {
        load() {
            this.$refs.tablePage.$refs.searchList.changeLoading(true);
            this.loading = true;
            const params = { pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize, ...this.searchDataLists };
            this.currentPage = this.searchObj.pageNo;
            this.totalData = [];
            getBillLists(params).then(res => {
                if (res && res.code === '0') {
                    const { BMS_SETTLEMENT_PROCESS, SYS_SU_PAYMENT_TERMS, SYS_BMS_BILL_STATUS } = window.sessionStorage;
                    var settlement = JSON.parse(BMS_SETTLEMENT_PROCESS);
                    const paymentTime = JSON.parse(SYS_SU_PAYMENT_TERMS);
                    const billStatus = JSON.parse(SYS_BMS_BILL_STATUS);
                    this.totalData = [];
                    res.data.list.forEach(item => {
                        item.checkDate = item.checkDate ? item.checkDate.split(' ')[0] : ''; // 对日期进行截取
                        item.signForTime = item.signForTime ? item.signForTime.split(' ')[0] : '';
                        item.openInvoiceDate = item.openInvoiceDate ? item.openInvoiceDate.split(' ')[0] : '';
                        item.settlementProcessName = item.settlementProcess === 1 ? settlement[1] : settlement[-1];
                        item.apApplyNo = item.settlementProcess === INDEPENDENT_SETTLEMENT ? item.apApplyNo : '';
                        if (item.settlementProcess !== 1) {
                            item.apRealAmt = item.totalAmt - (item.fineAmt ? item.fineAmt : 0) - (item.oilCardAmountPaid ? item.oilCardAmountPaid : 0);
                        }
                        item.subnum4 = paymentTime[item.subnum4];
                        item.verifyTotalAmt = ((item.buyOilAmt ? item.buyOilAmt : 0) + (item.chargeoffPreAmt ? item.chargeoffPreAmt : 0) + (item.fineAfterAmt ? item.fineAfterAmt : 0) +
                        (item.depositAmt ? item.depositAmt : 0) + (item.chargeoffArAmt ? item.chargeoffArAmt : 0) + (item.preInvoiceAmt ? item.preInvoiceAmt : 0)).toFixed(2);
                        item.billStatusTest = item.billStatus === SETTLE_APPLY_STATUS && item.apApplyNo ? SETTLE_APPLY : billStatus[item.billStatus];
                        this.totalData.push(item);
                    });
                    this.pageTotal = res.data.totalCount;
                }
                this.loading = false;
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
            }).catch(() => {
                this.$refs.tablePage.$refs.searchList.changeLoading(false);
                this.loading = false;
            });
        },
        pageChange(data) {
            this.searchObj.pageNo = data;
            this.load();
        },
        sizeChange(data) {
            this.currentPage = 1;
            this.searchObj.pageSize = data;
            this.searchObj.pageNo = 1;
            this.load();
        },
        searchChange(data) {
            this.searchObj.pageNo = 1;
            data = this.formattingData(data);
            this.searchDataLists = data;
            this.load();
        },
        openMsgConfirmbox(msg = '', config = {}) {
            return this.$msgbox({
                title: '请确认',
                message: msg,
                type: 'info',
                showCancelButton: true,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                confirmButtonText: '是',
                cancelButtonText: '否',
                ...config
            });
        },
        /**
         * 确认账单开始时间:startSubdateTime 确认账单结束时间:endSubdateTime 开票开始时间:startInvoiceTime 开票结束时间:endInvoiceTime
         * 收票开始日期:startExpireDateTime 收票结束日期:endExpireDateTime 付款开始日期:startPaymentTime  付款结束时间:endPaymentTime
         */
        formattingData(data) {
            const tempData = {
                startSubdateTime: data.subdate2 ? formatTime.formatDate(data.subdate2[0]) + ' 00:00:00' : '',
                endSubdateTime: data.subdate2 ? formatTime.formatDate(data.subdate2[1]) + ' 23:59:59' : '',
                startInvoiceTime: data.openInvoiceDate ? formatTime.formatDate(data.openInvoiceDate[0]) + ' 00:00:00' : '',
                endInvoiceTime: data.openInvoiceDate ? formatTime.formatDate(data.openInvoiceDate[1]) + ' 23:59:59' : '',
                startExpireDateTime: data.signForTime ? formatTime.formatDate(data.signForTime[0]) + ' 00:00:00' : '',
                endExpireDateTime: data.signForTime ? formatTime.formatDate(data.signForTime[1]) + ' 23:59:59' : '',
                startPaymentTime: data.checkDate ? formatTime.formatDate(data.checkDate[0]) + ' 00:00:00' : '',
                endPaymentTime: data.checkDate ? formatTime.formatDate(data.checkDate[1]) + ' 23:59:59' : '',
                createTimeFrom: data.createTime ? formatTime.formatDate(data.createTime[0]) + ' 00:00:00' : '',
                createTimeTo: data.createTime ? formatTime.formatDate(data.createTime[1]) + ' 23:59:59' : '',
                ...data
            };
            this.tempData = del(tempData, ['subdate2', 'signForTime', 'openInvoiceDate', 'checkDate', 'createTime']);
            return tempData;
        },
        rowDBclick(row) { // standardType 添加默认值
            this.$router.push({ query: { apBillNo: row.apBillNo, jobid: row.jobId, standardType: row.standardType || '1' }, path: `/bms/billDetails` });
        },
        ruleFun(val, str, id) {
            return val.every(item => item[str] === id);
        },
        batchSettle() {
            this.paymentParams = [];
            if (this.selectData.length > 1) {
                const ledgerId = this.selectData[0].ledgerId;
                const currencyCode = this.selectData[0].currencyCode;
                const subnum4 = this.selectData[0].subnum4;
                const companyNameNew = this.selectData[0].companyNameNew;
                // 校验会计主体，币种，付款条件
                if (!this.ruleFun(this.selectData, 'ledgerId', ledgerId) || !this.ruleFun(this.selectData, 'currencyCode', currencyCode)) {
                    this.$message({
                        type: 'error',
                        message: '会计主体、币种必须一致才可以提交申请付款！'
                    });
                    return false;
                }
                // 校验分公司
                if (!this.ruleFun(this.selectData, 'companyNameNew', companyNameNew) || !this.ruleFun(this.selectData, 'subnum4', subnum4)) {
                    this.$message({
                        type: 'error',
                        message: '分公司、付款条件必须一致才可以提交申请付款！'
                    });
                    return false;
                }
            }
            for (var i = 0; i < this.selectData.length; i++) {
                if (this.selectData[i].settlementProcess !== 1) {
                    this.$message({
                        type: 'error',
                        message: '账单号:' + this.selectData[i].apBillNo + '不属于应付变革上线范围,请联系分公司财务发起付款申请!'
                    });
                    return false;
                }
                if (this.selectData[i].billStatus !== 40) {
                    this.$message({
                        type: 'error',
                        message: '账单号:' + this.selectData[i].apBillNo + '状态只能为盖章确认才可以发起结算'
                    });
                    return false;
                }
                this.paymentParams.push({
                    jobId: this.selectData[i].jobId,
                    apBillNo: this.selectData[i].apBillNo
                });
            }
            if (this.paymentParams.length === 0) {
                this.$message({
                    type: 'error',
                    message: '请选择账单'
                });
                return;
            }
            checkPaymentHandler(this.paymentParams).then(res => {
                this.responseData = [];
                this.paymentMsg = '';
                if (res.data.code === '0') {
                    this.batchSettlementFun(this.paymentParams);
                } else if (res.data.code === '1') {
                    this.isSettleFlag = true;
                    this.dialogVisible = true;
                    this.paymentMsg = res.data.msg;
                    this.responseData = res.data.data;
                } else if (res.data.code === '2') {
                    this.isSettleFlag = false;
                    this.dialogVisible = true;
                    this.paymentMsg = res.data.msg;
                } else if (res.data.code === '3') {
                    this.isSettleFlag = false;
                    this.dialogVisible = true;
                    this.isCloseSettlement = false;
                    this.paymentMsg = res.data.msg;
                } else if (res.data.code === '9') {
                    this.openMsgConfirmbox(res.data.msg, { dangerouslyUseHTMLString: true }).then(() => {
                        // 是
                        this.batchSettlementFun(JSON.parse(res.data.data));
                    }).catch(() => {
                        // 否
                    });
                }
            });
        },
        handlePayment() {
            const responseArr = [];
            this.responseData.forEach(item => {
                if (item.billStatus !== 40) {
                    this.$message({
                        type: 'error',
                        message: '账单号:' + item.apBillNo + '状态只能为盖章确认才可以发起结算'
                    });
                    return false;
                };
                responseArr.push({
                    jobId: item.jobId,
                    apBillNo: item.apBillNo
                });
            });
            const params = this.paymentParams.concat(responseArr);
            this.batchSettlementFun(params);
        },
        handleCloseDialog() {
            this.dialogVisible = false;
        },
        handleClose() {
            this.dialogVisible = false;
            this.isCloseSettlement && this.batchSettlementFun(this.paymentParams);
        },
        batchSettlementFun(params) {
            batchSettlement(params).then(async res => {
                if (res.code === '0' && res.data.code === '0') {
                    this.dialogVisible = false;
                    // 更新付款申请智汇票开票标识
                    await updateApApplyEisInvoicing({ 'jobId': res.data.data.jobId });
                    this.$router.push({ query: { apApplyNo: res.data.data.apApplyNo, jobId: res.data.data.jobId, standardType: res.data.data.standardType }, path: '/bms/settleDetails' });
                } else {
                    this.$message({ type: 'error',
                        message: res.data.msg }
                    );
                }
            });
        },
        selectChange(data) {
            this.selectData = data;
            data.forEach(item => {
                this.apBillNo = item.apBillNo;
            });
            this.selected = [].concat(data);
        },
        initSearchParamsExecute(params) {
            this.$nextTick(() => {
                const params = { pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize, ...this.searchDataLists };
                this.$refs.tablePage.$refs.searchList.setQueryParams(params);
                this.load();
            });
        },
        // 首页跳转过来 参数处理
        handleTodo() {
            this.$set(this.searchDataLists, 'billStatus', this.$route.query.billStatus || '');
            this.$refs.tablePage.$refs.searchList.setQueryParams({ ...this.searchDataLists,
                billStatus: this.$route.query.billStatus || '',
                createTimeFrom: '',
                createTimeTo: '' });
            this.$router.replace({ query: {} });
            this.load();
        }
    },
    mounted() {
        initSessionData(['SRM_BMS_TASK_TYPE', 'SYS_SC_INVOICE_TYPE', 'BMS_SETTLEMENT_PROCESS', 'SYS_BMS_BILL_STATUS']);
        if (this.$route.query.from === 'todoList') {
            this.handleTodo();
        } else {
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        }
    },
    activated() {
        // 首页跳转过来 参数处理
        if (this.$route.query.from === 'todoList') {
            this.handleTodo();
        }
    }
};
</script>

<style lang="less" scoped>
</style>
